import { MeasureScheme } from '../enums/measure-scheme';

export const DEFAULT_MEASURE_SCHEME = MeasureScheme.default;
